// API utility functions for making authenticated requests
import { clearAuthData, getAuthToken } from "./auth"

/**
 * Make an authenticated API request
 */
export const fetchWithAuth = async (url, options = {}) => {
  const token = getAuthToken()

  const headers = {
    ...(options.headers || {})
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const response = await fetch(url, {
    ...options,
    headers
  })

  if (response.status === 401 || response.status === 403) {
    clearAuthData()
    if (window.location.pathname !== "/login") {
      window.location.replace("/login")
    }
  }

  return response
}

/**
 * GET
 */
export const apiGet = async (url, options = {}) => {
  const response = await fetchWithAuth(url, {
    method: "GET",
    ...options
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  return response.json()
}

/**
 * POST (still available if backend needs it)
 */
export const apiPost = async (url, data = {}, options = {}) => {
  const response = await fetchWithAuth(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {})
    },
    body: JSON.stringify(data),
    ...options
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  return response.json()
}

/**
 * PUT ✅ (use this for approve / activate / deactivate / block)
 */
export const apiPut = async (url, data = {}, options = {}) => {
  const response = await fetchWithAuth(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {})
    },
    body: JSON.stringify(data),
    ...options
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  return response.json()
}

/**
 * DELETE
 */
export const apiDelete = async (url, options = {}) => {
  const response = await fetchWithAuth(url, {
    method: "DELETE",
    ...options
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  return response.json()
}
